// '10': Paiement en espèces. GUT
// '20': Paiement par chèque. GUT
// '30': Virement bancaire. GUT
// '42': CONSIDERE COMME VIREMENT SUR CHORUS PRO
// Payment to bank account Payment by an arrangement for settling debts that is operated by the Post Office..
// '48': CONSIDERE COMME PRELEVEMENT SUR CHORUS PRO
// '49': CONSIDERE COMME PRELEVEMENT SUR CHORUS PRO
// '57': NON AUTORISÉ SUR CHORUS PRO
// Standing agreement The payment means have been previously agreed between seller and buyer and thus are not stated again..
// '58': CONSIDERE COMME VIREMENT SUR CHORUS PRO
// SEPA credit transfer Credit transfer inside the Single Euro Payment Area (SEPA) system..
// '59': CONSIDERE COMME PRELEVEMENT SUR CHORUS PRO
// SEPA direct debit Direct debit inside the Single Euro Payment Area (SEPA) system.
// '97': REPORT
// Clearing between partners Amounts which two partners owe to each other to be compensated in order to avoid useless payments.
// 'ZZZ': NON AUTORISÉ SUR CHORUS PRO
// Mutually defined A code assigned within a code list to be used on an interim basis and as defined among trading partners until a precise code can be assigned to the code list.
; (function (angular) {
  'use strict'

  // below are all mimetypes supported for Factur-X Attachments in CHORUS PRO
  angular
    .module('kilo.config')
    .constant('facturXPaymentsMethod', [
      {
        method: 'Liquide',
        code: '10'
      },
      {
        method: 'Virement',
        code: '30'
      },
      {
        method: 'Chèque',
        code: '20'
      },
      {
        method: 'Prélèvement',
        code: '48'
      },
      {
        method: 'Carte bancaire',
        code: '48'
      }
      // ,
      // {
      //   method: 'Report',
      //   code: '97'
      // }
    ])
})(window.angular)
